import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Switch, Typography } from '@material-ui/core';

import Select from '../../../../../../../commons/select/Select';
import { getCurrencySymbol } from '../../../../../../../conf/chargify';
import { isQuantityControl } from '../addOnValues';
import { useStyles } from './addOnsList.styles';

const MAX_QUANTITY = 10;

function getQuantityData () {
    const data = [];
    for (let i = 0; i <= MAX_QUANTITY; i++) {
        data.push({ label: i, value: i });
    }
    return data;
}

function AddOnsList ({ addOns, currency, values, onChange }) {
    const classes = useStyles();
    const symbol = getCurrencySymbol(currency);
    const [quantity] = useState(getQuantityData());

    if (!addOns.length) {
        return null;
    }

    return (
        <div>
            <Typography variant='body2' className={classes.sectionTitle}>
                Add your extras!
            </Typography>
            <div className={classes.list}>
                {addOns.map((addOn) => {
                    const isQuantity = isQuantityControl(addOn);
                    const perLabel = isQuantity ? 'each' : 'when enabled';
                    return (
                        <div key={addOn.id} className={classes.row}>
                            <div className={classes.rowInfo}>
                                <span className={classes.rowName}>{addOn.name}</span>
                                <span className={classes.rowPrice}>
                                    <span className={classes.rowPriceValue}>{`${symbol}${addOn.price}`}</span>
                                    {` ${perLabel}`}
                                </span>
                                {addOn.description && (
                                    <Typography variant='body2' className={classes.rowDesc}>
                                        {addOn.description}
                                    </Typography>
                                )}
                            </div>
                            <div className={classes.rowControl}>
                                {isQuantity ? (
                                    <Select
                                        marginBottom={0}
                                        id={`addon-${addOn.id}`}
                                        name={`addon-${addOn.id}`}
                                        value={values[addOn.id]}
                                        labelHeading=''
                                        placeHolder='Qty'
                                        dataForDropdown={quantity}
                                        handleChange={(e, selectedData) => {
                                            onChange(addOn.id, selectedData.props.value);
                                        }}
                                    />
                                ) : (
                                    <Switch
                                        checked={!!values[addOn.id]}
                                        onChange={() => onChange(addOn.id, !values[addOn.id])}
                                        color='primary'
                                        inputProps={{ 'aria-label': `${addOn.name} toggle` }}
                                    />
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

AddOnsList.propTypes = {
    addOns: PropTypes.array,
    currency: PropTypes.string,
    values: PropTypes.object,
    onChange: PropTypes.func.isRequired,
};

AddOnsList.defaultProps = {
    addOns: [],
    currency: '',
    values: {},
};

export default AddOnsList;
